<div class="spacing-top">
	<div data-testid="SUBSYS4_OSTEOTOMYWK_CANCEL_BTN" class="wrapper-back" (click)="back()" (keypress)="back()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ labels().OSTEOTOMY_WORKFLOW_COMPONENT_CANCEL_BTN }}</span>
	</div>
</div>

<div class="main-step">
	<div class="box-menu-settings active">
		<div class="row-box">
			<h4>{{ labels().OSTEOTOMY_WORKFLOW_COMPONENT_TITLE }}</h4>
		</div>
		<div class="row-box">
			<div class="box-suggestion">
				<p>
					{{ labels().OSTEOTOMY_WORKFLOW_COMPONENT_MESSAGE }}
				</p>
			</div>
		</div>
		<div class="row-box bones-area">

			@if (isLeft) {
			<div class="bones-wrapper right">

				<div class="right-side">
					@if (isLongLegVisible || isFemurVisible) {
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="proximal-femur-left" name="anatomicalSiteLeft" class="custom-control-input"
							[value]="apexSiteEnum.ProximalFemur" [(ngModel)]="site" />
						<label class="custom-control-label" for="proximal-femur-left">&nbsp;</label>
					</div>
					<div class="bones-divider-1"></div>
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="distal-femur-left" name="anatomicalSiteLeft" class="custom-control-input"
							[value]="apexSiteEnum.DistalFemur" [(ngModel)]="site" />
						<label class="custom-control-label" for="distal-femur-left">&nbsp;</label>
					</div>
					}
					@if (isTibiaVisible) {
					<div class="bones-divider-2"></div>
					}
					@if (isLongLegVisible || isTibiaVisible) {
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="proximal-tibia-left" name="anatomicalSiteLeft" class="custom-control-input"
							[value]="apexSiteEnum.ProximalTibia" [(ngModel)]="site" />
						<label class="custom-control-label" for="proximal-tibia-left">&nbsp;</label>
					</div>
					<div class="bones-divider-1"></div>
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="distal-tibia-left" name="anatomicalSiteLeft" class="custom-control-input"
							[value]="apexSiteEnum.DistalTibia" [(ngModel)]="site" />
						<label class="custom-control-label" for="distal-tibia-left">&nbsp;</label>
					</div>
					}
				</div>
				<label class="info-leg-bottom" for="apex-site-left">{{ apexSiteLabel(site) }}</label>
			</div>
			}

			@if (isRight) {
			<div class="bones-wrapper left">
				<div class="left-side">
					@if (isLongLegVisible || isFemurVisible) {
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="proximal-femur-right" name="anatomicalSiteRight" class="custom-control-input"
							[value]="apexSiteEnum.ProximalFemur" [(ngModel)]="site" />
						<label class="custom-control-label" for="proximal-femur-right">&nbsp;</label>
					</div>
					<div class="bones-divider-1"></div>
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="distal-femur-right" name="anatomicalSiteRight" class="custom-control-input"
							[value]="apexSiteEnum.DistalFemur" [(ngModel)]="site" />
						<label class="custom-control-label" for="distal-femur-right">&nbsp;</label>
					</div>
					}
					@if (isTibiaVisible) {
					<div class="bones-divider-2"></div>
					}
					@if (isLongLegVisible || isTibiaVisible) {
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="proximal-tibia-right" name="anatomicalSiteRight" class="custom-control-input"
							[value]="apexSiteEnum.ProximalTibia" [(ngModel)]="site" />
						<label class="custom-control-label" for="proximal-tibia-right">&nbsp;</label>
					</div>
					<div class="bones-divider-1"></div>
					<div class="custom-control bones-control custom-radio">
						<input type="radio" id="distal-tibia-right" name="anatomicalSiteRight" class="custom-control-input"
							[value]="apexSiteEnum.DistalTibia" [(ngModel)]="site" />
						<label class="custom-control-label" for="distal-tibia-right">&nbsp;</label>
					</div>
					}
				</div>
				<label class="info-leg-bottom" for="apex-site-right">{{ apexSiteLabel(site) }}</label>
			</div>
			}

		</div>
		<div class="bottom-margin"></div>
		<div class="container-btn-confirm">
			<div class="divider-box"></div>
			<div class="wrapper-btn-confirm">
				<button data-testid="SUBSYS4_OSTEOTOMYWK_CONFIRM_BTN" type="button" class="btn btn-primary px-2"
					[disabled]="!site" (click)="confirm()">
					{{ labels().OSTEOTOMY_WORKFLOW_COMPONENT_CONFIRM_BTN }}
				</button>
			</div>
		</div>
	</div>
</div>